import React, { Component } from 'react';
import { db, timeStamp } from '../../../auth/authService';
import AdminPageLayout from './AdminPageLayout';
import './style.css';

import {
  Dimmer,
  Loader,
  List,
  Header,
  Table,
  Image,
  Button
} from 'semantic-ui-react';

import styled from 'styled-components';

const StyledCell = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export default class ContactUs extends Component {
  constructor(props) {
    super();

    this.state = { messageList: [] };
  }
  componentDidMount() {
    db.collection('messages')
      .orderBy('createdAt', 'desc')
      .get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc => {
          this.setState({
            messageList: [...this.state.messageList, doc.data()]
          });
        });
      })
      .catch(err => {
        console.log(err);
      });
  }
  render() {
    const { messageList } = this.state;
    console.log(messageList);
    return (
      <AdminPageLayout>
        <Header>ContactUs Message List</Header>
        <Table celled textAlign={'center'}>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>Name</Table.HeaderCell>
              <Table.HeaderCell>Email</Table.HeaderCell>
              <Table.HeaderCell>Message</Table.HeaderCell>
              <Table.HeaderCell>createdAt</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {messageList.map((message, index) => {
              let createdAt = message.createdAt.toDate().toDateString();

              return (
                <Table.Row key={index + 'row'}>
                  <Table.Cell key={index + 'name'} selectable>
                    {message.name}
                  </Table.Cell>
                  <Table.Cell key={index + 'email'} selectable>
                    {message.email}
                  </Table.Cell>
                  <Table.Cell key={index + 'message'} selectable>
                    <p style={{ whiteSpace: 'pre-line' }}>{message.message}</p>
                  </Table.Cell>
                  <Table.Cell key={index + 'createdAt'} selectable>
                    {createdAt}
                  </Table.Cell>
                </Table.Row>
              );
            })}
          </Table.Body>
        </Table>
      </AdminPageLayout>
    );
  }
}
